// Canonical types for the AI Feed feature. All field names are camelCase —
// the repo's axios-case-converter middleware handles wire-format conversion.

export enum AiFeedItemProducer {
  avCallExtraction = "av_call_extraction",
  amazonCiqExtraction = "amazon_ciq_extraction",
}

export enum AiFeedItemStatus {
  pending = "pending",
  accepted = "accepted",
  rejected = "rejected",
  expired = "expired",
}

export enum AiFeedItemType {
  createCondition = "create_condition",
}

export interface SnomedCodeSelection {
  code: string;
  system: string;
  display: string;
}

export type CodeSuggestion = SnomedCodeSelection;

export interface CreateConditionIntent {
  itemType: AiFeedItemType.createCondition;
  patientId: string;
  extractedTerm: string;
  suggestions: CodeSuggestion[];
}

export interface AiFeedItem {
  aiFeedItemId: number;
  encounterId: string;
  patientId: string;
  producer: AiFeedItemProducer;
  sourceFhirResource: string | null;
  sourceLocation: string | null;
  btSpanId: string | null;
  itemType: AiFeedItemType;
  intent: CreateConditionIntent | Record<string, unknown>;
  selectedCode: SnomedCodeSelection | null;
  status: AiFeedItemStatus;
  resolvedAt: string | null;
  resolvedBy: number | null;
  resolvedByName: string | null;
  targetFhirResource: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy: number;
  updatedBy: number;
}

export function isCreateConditionItem(
  item: AiFeedItem,
): item is AiFeedItem & { intent: CreateConditionIntent } {
  return (
    item.itemType === AiFeedItemType.createCondition &&
    Array.isArray((item.intent as CreateConditionIntent)?.suggestions ?? [])
  );
}
